import Translate from "utils/Translate";
import { AppContext } from "contexts/AppContext";
import { useContext } from "react";
import { upgColors, fontFamily } from "styles/styles";

const ExplainerText = (props) => {
  const { styleGuide } = useContext(AppContext)
    const explainerTextStyle = {
      fontFamily: styleGuide.secondaryFontFamily,
      fontWeight: styleGuide.explainerTextFontWeight,
      fontSize: styleGuide.explainerTextFontSize,
      fontStyle: 'normal',
      lineHeight: styleGuide.explainerTextLineHeight,
      color: styleGuide.color7
    }

  
    return (
      <span onClick={props.onClick} style={{...explainerTextStyle, ...props.style}} className={props.className} >
        {props.configuredLabel ? props.configuredLabel : <Translate translationKey={props.translationKey}>{props.fallbackText || props.children}</Translate>}
      </span>
    )
}

export default ExplainerText;